import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import type { Movement } from '#src/app/pages/petitionDetails/shared/types';

export function useFirstMovement(): Movement | undefined {
	const {
		data: {
			petition: { movements },
		},
	} = usePetitionDetailsPageData();

	return movements.nodes[0];
}
